if (!customElements.get("cart-remove-button")) {
  customElements.define(
    "cart-remove-button",
    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();

        this.addEventListener("click", (event) => {
          event.preventDefault();
          setTimeout(() => {
            if(document.getElementsByClassName('cart-item__details')){
              document.getElementsByClassName('cart-item__details').forEach(item => {
                if (item.querySelector(".cart-item__name").textContent.includes("Gift Card")) {
                  item.querySelectorAll(".product-option").forEach((option) => {
                      if(option.querySelector("dt") && option.querySelector("dd")){
                          option.querySelector("dt").textContent === "Recipient email:" ? option.querySelector("dt").textContent = "E-mail do presenteado:" : null;
                          option.querySelector("dt").textContent === "Send on:" ? option.querySelector("dt").textContent = "Data de envio:" : null;
                          if( window.innerWidth < 768 && (option.querySelector("dt").textContent === "Message:" || option.querySelector("dt").textContent === "Mensagem:")){
                            option.querySelector("dt").remove();
                            option.querySelector("dd").remove();
                          } else {
                            option.querySelector("dt").textContent === "Message:" ? option.querySelector("dt").textContent = "Mensagem:" : null;
                          }
                      }
                  })
                }
              })
            } 
          }, 1000)
          const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
          cartItems.updateQuantity(this.dataset.index, 0);
        });
      }
    },
  );
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    changePriceRegular = document.querySelectorAll(".price.price--end");
    changePriceRegular.forEach((element) => {
      element.textContent = element.textContent.trim().replace(",", "");
    });
    const changePriceCart = document.querySelectorAll(".cart__checkout-button.button");
    changePriceCart.forEach((element) => {
      element.textContent = element.textContent.trim().replace(",", "");
    });
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.cartLimits = document.querySelector("cart-limits");
    this.maxPerVariant = this.cartLimits.maxPerVariant;

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === "cart-items") {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  getCart(callback) {
    fetch(`${routes.cart_url}.js`)
      .then((response) => {
        return response.json();
      })
      .then((cart) => {
        callback(cart);
      });
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target?.max,
    );
    setTimeout(() => {
      if(document.getElementsByClassName('cart-item__details')){
        document.getElementsByClassName('cart-item__details').forEach(item => {
          if (item.querySelector(".cart-item__name").textContent.includes("Gift Card")) {
              item.querySelectorAll(".product-option").forEach((option) => {
                  if(option.querySelector("dt") && option.querySelector("dd")){
                      option.querySelector("dt").textContent === "Recipient email:" ? option.querySelector("dt").textContent = "E-mail do presenteado:" : null;
                      option.querySelector("dt").textContent === "Send on:" ? option.querySelector("dt").textContent = "Data de envio:" : null;
                      if( window.innerWidth < 768 && (option.querySelector("dt").textContent === "Message:" || option.querySelector("dt").textContent === "Mensagem:")){
                        option.querySelector("dt").remove();
                        option.querySelector("dd").remove();
                      } else {
                        option.querySelector("dt").textContent === "Message:" ? option.querySelector("dt").textContent = "Mensagem:" : null;
                      }
                  }
                
              })
          }
        })
      }
    }, 1000)
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, maxElementQuantity) {    
    const maxQuantity = parseInt(maxElementQuantity);
    if (!!maxQuantity) {
      if (quantity > maxQuantity) return;
    }

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    const _requestConfig = {
      ...fetchConfig(),
    }
      const addToCartOriginalPayload = (() => {
        const __lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        const __variantId = __lineItem ? __lineItem.dataset.variantid : null;
        const __quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const quantityChanged = Number(quantity) - Number(__quantityElement.dataset.cartQuantity);
        if (quantityChanged <= 0) return null;
        return JSON.stringify({
          "items": [
            {
              "id": Number(__variantId),
              "quantity": quantityChanged
            }
          ]
        })
      })()
                          

    _requestConfig.headers["site-placement"] = "cart-items"
    if(addToCartOriginalPayload) _requestConfig.headers["add-to-cart-original-payload"] = addToCartOriginalPayload

    fetch(`${routes.cart_change_url}`, { ..._requestConfig, ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = "";
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace("[quantity]", updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector(".drawer__inner-empty"), cartDrawerWrapper.querySelector("a"));
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) => overlay.classList.add("hidden"));
        const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);

        this.updateKits();
      });
  }

  updateKits() {
    const kitsOnCart = {};
    // get cart
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        if (!cart || !cart.items) return;
        cart.items.forEach((item) => {
          if (item.properties && item.properties.handlesKit) {
            const kitName = item.properties.handlesKit.name;
            const kitTotalQty = item.properties.handlesKit.totalQty;
            if (kitsOnCart[kitName]) {
              kitsOnCart[kitName]["items"].push(item);
              kitsOnCart[kitName]["quantity"] += item.quantity;
            } else {
              kitsOnCart[kitName] = {
                items: [item],
                quantity: item.quantity,
                totalQty: kitTotalQty,
              };
            }
          }
        });

        Object.keys(kitsOnCart).forEach((kitName) => {
          const kit = kitsOnCart[kitName];

          if (kit.totalQty > kit.quantity) {
            // update cart removing items from kit
            const updates = {};
            kit.items.forEach((item) => {
              updates[item.id] = 0;
            });

            const body = JSON.stringify({
              updates,
              sections: this.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname,
            });

            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);
                if (parsedState.errors) {
                  return;
                }

                this.classList.toggle("is-empty", parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector("cart-drawer");
                const cartFooter = document.getElementById("main-cart-footer");

                if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section) => {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) ||
                    document.getElementById(section.id);
                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector,
                  );
                });

                if (parsedState.item_count === 0 && cartDrawerWrapper) {
                  trapFocus(
                    cartDrawerWrapper.querySelector(".drawer__inner-empty"),
                    cartDrawerWrapper.querySelector("a"),
                  );
                } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
                  trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
                }
                publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
              })
              .catch((e) => {
                console.error(e);
              });
          }
        });
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove("hidden"));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add("hidden"));
  }
}
if (!customElements.get("cart-items")) {
  customElements.define("cart-items", CartItems);
}

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}

class CartFreeShipping extends HTMLElement {
  constructor() {
    super();

    this.freeShippingValue = parseInt(this.getAttribute("data-free-shipping-value")) * 100;
    this.customMessage = /true/.test(this.getAttribute("data-custom-message"));
    this.customMessageValue = parseInt(this.getAttribute("data-custom-message-value")) * 100;
    this.progressBar = this.querySelector(".cart-free-shipping__progress span");
    this.progressTextSingular = this.querySelector(".cart-free-shipping__inner p.singular");
    this.progressTextPlural = this.querySelector(".cart-free-shipping__inner p.plural");
    this.progressTextCustom = this.querySelector(".cart-free-shipping__inner p.custom");
    this.progressTextSuccess = this.querySelector(".cart-free-shipping__inner p.success");
    this.freeGift = /true/.test(this.getAttribute("data-custom-gift"));
    this.freeGiftValue = parseInt(this.getAttribute("data-custom-gift-value")) * 100;
    this.freeGiftText = this.querySelector("cart-free-shipping p.gift");
    this.giftTextSuccess = this.querySelector("cart-free-shipping p.gift-success");
    this.shippingCalculatorText = document.querySelector(".shipping-calculator__header p");
    this.updateFreeShippingProgress();
  }

  getCart(callback) {
    fetch(`${routes.cart_url}.js`)
      .then((response) => {
        return response.json();
      })
      .then((cart) => {
        callback(cart);
      });
  }

  formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace(".", ",");
    return `R$ ${value.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  }

  updateFreeShippingProgress() {
    this.getCart((cart) => {
      if (this.freeGift) {
        const progress = (cart.total_price / this.freeGiftValue) * 100;
        if(this.progressBar) this.progressBar.style.width = `${progress <= 100 ? progress : 100}%`;
      } else {
        const progress = (cart.total_price / this.freeShippingValue) * 100;
        if(this.progressBar) this.progressBar.style.width = `${progress <= 100 ? progress : 100}%`;
      }

      const valueDif = this.freeShippingValue - cart.total_price;
      const valueCustom = this.customMessageValue - cart.total_price;
      const valueGift = this.freeGiftValue - cart.total_price;
      if (valueDif > 0) {
        if (this.customMessage) {
          if (this.progressTextCustom) {
            this.progressTextCustom.innerHTML = window.cartStrings.freeShippingProgressCustom
              .replace("[money]", this.formatMoney(valueDif))
              .replace("[value]", this.formatMoney(valueCustom));

            this.progressTextCustom.style.display = "block";
          }
          if (this.progressTextSingular) this.progressTextSingular.style.display = "none";
          if (this.progressTextPlural) this.progressTextPlural.style.display = "none";
          if (this.progressTextSuccess) this.progressTextSuccess.style.display = "none";
        } else {
          if (this.progressTextPlural) {
            this.progressTextPlural.innerHTML = window.cartStrings.freeShippingProgressPlural.replace(
              "[money]",
              this.formatMoney(valueDif),
            );
            this.progressTextPlural.style.display = "block";
          }
          if (this.progressTextCustom) this.progressTextCustom.style.display = "none";
          if (this.progressTextSingular) this.progressTextSingular.style.display = "none";
          if (this.progressTextSuccess) this.progressTextSuccess.style.display = "none";
          if (this.shippingCalculatorText) this.shippingCalculatorText.textContent = "CALCULE SEU FRETE";
        }
      } else {
        if (this.progressTextCustom) this.progressTextCustom.style.display = "none";
        if (this.progressTextSingular) this.progressTextSingular.style.display = "none";
        if (this.progressTextPlural) this.progressTextPlural.style.display = "none";
        if (this.progressTextSuccess) this.progressTextSuccess.style.display = "block";
        if (this.shippingCalculatorText) this.shippingCalculatorText.textContent = "Prazo de entrega";
      }
      if (this.freeGift) {
        if (cart.total_price < this.freeGiftValue) {
          if (this.freeGiftText) {
            this.freeGiftText.innerHTML = window.cartStrings.freeGift.replace("[money]", this.formatMoney(valueGift));
            this.freeGiftText.style.display = "block";
          }
        } else {
          if (this.freeGiftText) this.freeGiftText.style.display = "none";
          if (this.giftTextSuccess) this.giftTextSuccess.style.display = "block";
        }
      }
    });
  }
}
customElements.define("cart-free-shipping", CartFreeShipping);
